<template>
<div>
  <div class="content">
    <van-form @submit="onSubmit" ref="formRef">
      <van-field v-model="username" name="username" label="用户名" placeholder="用户名" maxlength="10" :rules="[{ required: true, message: '请填写用户名' }]" @input="refreshDriver" />
      <van-field v-model="mobile" type="tel" name="mobile" label="手机号码" placeholder="手机号码" :rules="[{ required: true, message: '请填写手机号码' }]" @input="refreshDriver" />

      <div class="add-btn-box">
        <van-button round block type="info" class="addBtn" color="#316892">
          提交
        </van-button>
      </div>
    </van-form>
  </div>
  <Tabbar></Tabbar>
</div>
</template>

<script>
import store from '@/store/index'
import api from "@/fetch/api"
import Tabbar from '../Public/tabbarTpl.vue'
import {
  Dialog,
  Toast
} from 'vant'

export default {
  components: {
    Tabbar
  },
  metaInfo: {
    title: '用户信息',
  },
  data() {
    return {
      username: '',
      mobile: '',
      navTitle: "",
      leftText: "",
      rightText: "首页",
      leftArrow: true,
      activeName: 'all',
      vehicleState: '03'
    };
  },
  created: function() {
    var that = this;
    var mobile = that.$store.state.wx_info.mobile ? that.$store.state.wx_info.mobile : "";

    if (mobile) {
      var username = that.$store.state.wx_info.username ? that.$store.state.wx_info.username : "";
      that.$data.username = username;
      that.$data.mobile = mobile;
      that.$data.navTitle = "修改用户信息";
      document.title = "修改用户信息";
    } else {
      var isAccept = sessionStorage.isAccept;
      that.$data.navTitle = "绑定用户信息";
      document.title = "绑定用户信息";
      if (!isAccept) {
        that.$router.push({
          name: 'protocol'
        });
      }
    }
  },
  mounted() {
      const steps = [
        {
          popover: {
            title: '🎉欢迎使用<br>苏豪丽天蒸洗预约系统',
            description: '接下来跟随引导完成您的第一份预约订单!',
            showButtons: ['next'],
            nextBtnText: '开始引导',
            onPopoverRender: (popover) => {
              // 设置跳过引导按钮
              const firstButton = document.createElement("button");
              firstButton.innerText = "跳过引导";
              popover.footerButtons.appendChild(firstButton);
              firstButton.addEventListener("click", () => {
                this.$driverObj.destroy();
                store.commit('set_firstTime')
              });
            },
          },
        },
        {
          element: '.van-form',
          popover: {
            title: '请填写个人信息',
            // description: '',
            showButtons: ['next'],
            onNextClick: (element, step, options) => {
              this.$refs.formRef
                  .validate()
                  .then(() => {
                    this.$driverObj.moveNext();
                  })
                  .catch((err) => {
                    this.$driverObj.refresh();
                  });
            },
          },
        },
        {
          element: '.add-btn-box .van-button',
          popover: {
            title: '点击按钮完成操作',
            // description: '点击按钮完成操作',
            showButtons: ['previous']
          },
        },
      ]
    if (store.state.isFirstTime) {
      this.$driverObj.setSteps(steps);
      if (this.$route.query.bootFlag === 'firstTime') {
        this.$driverObj.drive();
      } else {
        this.$driverObj.drive(1);
      }
    }
  },
  destroyed() {
    store.state.isFirstTime && this.$driverObj.destroy()
  },
  methods: {
    refreshDriver() {
      store.state.isFirstTime && this.$driverObj.refresh();
    },
    onSubmit(values) {
      var username = values.username;
      var mobile = values.mobile;
      var openid = this.$store.state.wx_info.openid ? this.$store.state.wx_info.openid : "";

      if (openid == "") {
        console.log('清空记录，重新获取openid');
      }

      if (!(/^1[3456789]\d{9}$/.test(mobile))) {
        Toast.fail('手机号码有误，请重填');
        return false;
      }

      const that = this;

      var bindMobile = that.$store.state.wx_info.mobile ? that.$store.state.wx_info.mobile : "";

      if (bindMobile) {
        api.bindUserInfo(openid, username, mobile).then(function(resData) {
          var res = JSON.parse(resData);
          if (res.respCode == 0) {
            that.$store.commit('set_username', username);
            that.$store.commit('set_mobile', mobile);
            Dialog.alert({
              message: '保存用户信息成功',
            }).then(() => {
              that.$router.push({
                name: 'index',
                query: {
                  bootFlag: 'bindPhone'
                }
              })
            });
          } else if (res.respCode < 0) {
            Dialog.alert({
              message: res.message,
            }).then(() => {
              that.$router.push({
                name: 'index',
                query: {
                  bootFlag: 'bindPhone'
                }
              })
            });
          } else {
            Toast.fail('连接异常');
          }
        }).catch(function(err) {
          console.log(err);
          Toast.fail('连接失败，请刷新页面');
        }).finally(() => {
          this.$driverObj.destroy()
        });
      } else {
        api.addUserInfo(openid, username, mobile).then(function(resData) {
          var res = JSON.parse(resData);
          if (res.respCode == 0) {
            that.$store.commit('set_username', username);
            that.$store.commit('set_mobile', mobile);
            that.$store.commit('set_vehicleState', "02");
            Dialog.alert({
              message: '保存用户信息成功',
            }).then(() => {
              that.$router.push({
                name: 'index',
                query: {
                  bootFlag: 'bindPhone'
                }
              })
            });
          } else if (res.respCode < 0) {
            Dialog.alert({
              message: res.message,
            }).then(() => {
              that.$store.commit('set_firstTime');
              that.$router.push({
                name: 'index',
                query: {
                  bootFlag: 'bindPhone'
                }
              })
            });
          } else {
            Toast.fail('连接异常');
          }
        }).catch(function(err) {
          console.log(err);
          Toast.fail('连接失败，请刷新页面');
        }).finally(() => {
          this.$driverObj.destroy()
        });
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.content {
    margin-top: 1rem;
    .add-btn-box {
      position: fixed;
      bottom: 3.75rem;
      left: .5rem;
      right: .5rem;
      line-height: 3.75rem;
      padding-bottom: env(safe-area-inset-bottom);
    }
}
</style>
